import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import { Loader } from '@pw-tech/omni-ui';
interface ChildrenProps {
  formSteps: Array<{
    key: string;
    label: string;
    description: string;
    component: React.ComponentType<any>;
  }>;
}
const Children = ({
  formSteps
}: ChildrenProps) => {
  const router = useRouter();
  const {
    registrationDetails,
    isFormSubmitting
  } = useContext(RegistrationContext);
  const {
    step
  } = router.query;
  return <>
      {isFormSubmitting && !registrationDetails?._id ? <div className="flex items-center justify-center h-full">
          <Loader message="Loading..." />
        </div> : formSteps.filter(stepItem => stepItem.key === (step ?? registrationDetails?.step?.toString() ?? '1')).map(stepItem => {
      const Component = stepItem.component;
      return <Component key={stepItem.key} />;
    })}
    </>;
};
export default Children;